<div class="wallboardViewSlide" [attr.mid]="moduleKey"
    [ngStyle]="{'background-image':'url(../Admin/ImageResizer.aspx?imgid=' + backgroundID + '&w=1920&h=1080)'}">
    <div class="wallboardViewSlideContentArea wallboardViewSlideContentAreaLight">
        <div style="box-sizing: border-box;">
            <div class="wvCurrentAgentStatesTitle"
                 style="width: 100%; border-radius: 12px; display: flex; font-size: 26px; text-align: center;"
                 [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                <div class="summaryTitle txtOverflow" style="width: 50%; height: 100%; flex: 50; text-align: left;">
                    <span style="margin-top: 16px; display: inline-block;">{{currentAgentStatesState?.SlideTitle}}</span>
                </div>
                <div style="display: inline-block; width: 50%; height: 100%; flex: 20;">
                    <div cvLocalizedText langSection="Queue_Counter" langKey="Contacts_In_Queue">Calls in Queue</div>
                    <div>{{currentAgentStatesData?.CallsInQueueCount}}</div>
                </div>
                <div style="display: inline-block; width: 30%; height: 100%; flex: 30;">
                    <div cvLocalizedText langSection="Module" langKey="Longest_Call_In_Queue">
                        Longest Call in Queue
                    </div>
                    <div>{{currentAgentStatesData?.LongestCallInQueueFormatted}}</div>
                </div>
                <div style="display: inline-block; width: 20%; height: 100%; flex: 20;">
                    <div cvLocalizedText langSection="Module" langKey="Total_Agents">Total Agents</div>
                    <div>{{currentAgentStatesData?.TotalCount}}</div>
                </div>
            </div>
        </div>
        <!-- state counters -->
        <div style="box-sizing: border-box;">
            <div class="wvCurrentAgentStatesTitle"
                 style="width: 100%; border-radius: 12px; display: flex; font-size: 26px; text-align: center;"
                 [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                <div>
                    <span>{{currentAgentStatesData?.AgentStateCategories?.["Inbound"]}}</span>
                    <!--Inbound-->
                    <span class="wvCurrentAgentStatesStateBox"
                          style="padding: 0px 10px; display: inline-block; background-color: #7C52BF; margin-bottom: 16px;">{{currentAgentStatesData?.InboundCount}}</span>
                </div>
                <div>
                    <span>{{currentAgentStatesData?.AgentStateCategories?.["Outbound"]}}</span>
                    <!--Outbound-->
                    <span class="wvCurrentAgentStatesStateBox"
                          style="padding: 0px 10px; display: inline-block; background-color: #E4B321; margin-bottom: 16px;">{{currentAgentStatesData?.OutboundCount}}</span>
                </div>
                <div class="wvCurrentAgentStatesColumnTitle"
                     style="min-height: 45px; max-height: 90px; grid-row-start: 1; grid-column: span 3;">
                    <span>{{currentAgentStatesData?.AgentStateCategories?.["Unavailable"]}}</span>
                    <!--Unavailable-->
                    <span class="wvCurrentAgentStatesStateBox"
                          style="padding: 0px 10px; display: inline-block; background-color: #BD2026; margin-bottom: 16px;">{{currentAgentStatesData?.UnavailableCount}}</span>
                </div>
                <div class="wvCurrentAgentStatesColumnTitle"
                     style="min-height: 45px; max-height: 90px; grid-row-start: 1; grid-column: span 3;">
                    <span>{{currentAgentStatesData?.AgentStateCategories?.["Available"]}}</span>
                    <!--Available-->
                    <span class="wvCurrentAgentStatesStateBox"
                          style="padding: 0px 10px; display: inline-block; background-color: #3D9649; margin-bottom: 16px;">{{currentAgentStatesData?.AvailableCount}}</span>
                </div>
            </div>
        </div>
        <!-- table -->
        <div class="clearBoth"></div>
        <div class="wvCurrentAgentStatesTableData">
            <!-- Group Name -->
            <div class="wvCurrentAgentStatesColumn"
                 style="flex: 2; max-width: 25%; display: grid; grid-template-columns: auto"
                 [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                <div class="wvCurrentAgentStatesColumnTitle"
                     style="min-height: 90px; max-height: 180px; grid-row-start: 1; grid-column:span 1;">
                    Name
                </div>
                <ng-container *ngFor="let item of paddedData[0]; let $index = index;">
                    <div class="wvCurrentAgentStatesStateIndicator"
                         [ngStyle]="{'background-color': getStateColor(item.state), 'grid-row-start':$index+2}">
                    </div>
                    <div class="wvCurrentAgentStatesGridCell wvCASEllip" [ngStyle]="{'grid-row-start':$index+2}">
                        {{item.groupName}}
                    </div>
                </ng-container>
            </div>

            <!-- State Name -->
            <div class="wvCurrentAgentStatesColumn"
                 style="flex: 1; max-width: 25%; display: grid; grid-template-columns: auto;"
                 [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                <div class="wvCurrentAgentStatesColumnTitle"
                     style="min-height: 45px; max-height: 90px; grid-row-start: 1; grid-column: span 1;">
                    State
                </div>
                <ng-container *ngFor="let item of paddedData[1]; let $index = index">
                    <div class="wvCurrentAgentStatesGridCell" [ngStyle]="{'grid-row-start':$index+2}">
                        {{item.stateName}}
                    </div>
                </ng-container>
            </div>
            <!-- Time -->
            <div class="wvCurrentAgentStatesColumn"
                 style="flex: 1; max-width: 25%; display: grid; grid-template-columns: auto;"
                 [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                <div class="wvCurrentAgentStatesColumnTitle"
                     style="min-height: 45px; max-height: 90px; grid-row-start: 1; grid-column: span 1;">
                    Time
                </div>
                <ng-container *ngFor="let item of paddedData[2]; let $index = index">
                    <div class="wvCurrentAgentStatesGridCell" [ngStyle]="{'grid-row-start':$index+2}">
                        {{item.stateTime}}
                    </div>
                </ng-container>
            </div>
            <!-- Team -->
            <div class="wvCurrentAgentStatesColumn"
                 style="flex: 1; max-width: 25%; display: grid; grid-template-columns: auto;"
                 [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                <div class="wvCurrentAgentStatesColumnTitle"
                     style="min-height: 45px; max-height: 90px; grid-row-start: 1; grid-column: span 1;">
                    Team
                </div>
                <ng-container *ngFor="let item of paddedData[3]; let $index = index">
                    <div class="wvCurrentAgentStatesGridCell" [ngStyle]="{'grid-row-start':$index+2}">
                        {{item.parentGroupName}}
                    </div>
                </ng-container>
            </div>
            <!-- Source -->
            <div class="wvCurrentAgentStatesColumn"
                 style="flex: 1; max-width: 25%; display: grid; grid-template-columns: auto;"
                 [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                <div class="wvCurrentAgentStatesColumnTitle"
                     style="min-height: 45px; max-height: 90px; grid-row-start: 1; grid-column: span 1;">
                    Source
                </div>
                <ng-container *ngFor="let item of paddedData[4]; let $index = index">
                    <div class="wvCurrentAgentStatesGridCell" [ngStyle]="{'grid-row-start':$index+2}">
                        {{item.skill == "" ? "---" : item.skill}}
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
